module.exports = __webpack_public_path__ + "img/utilityvalve_stopped.f01ea5ba.svg";